<template>
  <div ref="homeUl" class="testPaper edit-style detail">
    <!-- {{ searchData }} -->
    <div class="navigation">
      <van-icon name="arrow-left" size="24" @click="downView" />
      <p class="title">试卷库</p>
      <div class="hidden-box"></div>
      <!-- <img src="@/assets/learning/setting.png" alt="" @click="toSetting" /> -->
    </div>
    <div class="muen-box">
      <div @click="showGrade = true">
        <span>{{ gradeVal }}</span>
        <van-icon name="arrow-down" />
      </div>
      <div @click="showSubject = true">
        <span>{{ subjectVal }}</span>
        <van-icon name="arrow-down" />
      </div>
      <div @click="showExamType = true">
        <span>{{ examTypeVal }}</span>
        <van-icon name="arrow-down" />
      </div>
      <div @click="showYear = true">
        <span>{{ yearTypeVal }}</span>
        <van-icon name="arrow-down" />
      </div>
    </div>
    <!-- {{ top }}
    {{ height }} -->
    <div class="paper-list-box">
      <div
        v-for="(v, i) in paperList"
        :key="i"
        class="paper-list"
        @click="linkTo(v)"
      >
        <img src="@/assets/bookIcon.png" alt="" />
        <div
          class="tips"
          :class="{
            'one-color': v.type % 1 == 0,
            'two-color': v.type % 2 == 0,
            'three-color': v.type % 3 == 0,
            'four-color': v.type % 5 == 0,
            'five-color': v.type % 7 == 0,
          }"
        >
          <span>{{ v.type | cutName(examTypeOptions) }}</span>
        </div>
        <p>{{ v.name }}</p>
        <div class="paper-list-cnt">
          <span>{{ v.resGradeId | setName(gradeOption) }}</span>
          <span>{{ v.type | setName(examTypeOptions) }}</span>
        </div>
        <div class="paper-list-time">
          <span class="time">浏览：{{ v.countView }}</span>
          <span>|</span>
          <span class="time">{{ v.updateTime }}更新</span>
        </div>
      </div>
      <div class="loading-box">
        <van-loading v-if="current < pages" size="24px">加载中...</van-loading>
        <van-divider v-else dashed>没有找到更多了</van-divider>
      </div>
    </div>

    <van-popup v-model="showGrade" round position="bottom">
      <van-picker
        show-toolbar
        :columns="gradeList"
        @cancel="showGrade = false"
        @confirm="onConfirmGrade"
      />
    </van-popup>
    <van-popup v-model="showSubject" round position="bottom">
      <van-picker
        show-toolbar
        :columns="subjectList"
        @cancel="showSubject = false"
        @confirm="onConfirmSubject"
      />
    </van-popup>
    <van-popup v-model="showExamType" round position="bottom">
      <van-picker
        show-toolbar
        :columns="examTypeList"
        @cancel="showExamType = false"
        @confirm="onConfirmExamType"
      />
    </van-popup>
    <van-popup v-model="showYear" round position="bottom">
      <van-picker
        show-toolbar
        :columns="yearList"
        @cancel="showYear = false"
        @confirm="onConfirmYear"
      />
    </van-popup>
  </div>
</template>

<script>
import {
  gradeHighOptions,
  gradeMiddleOptions,
  subjectOptions,
  examTypeOptions,
} from "@/util/constdata";
import { systemPage } from "@/api/interface";
export default {
  name: "TestPaper",
  data() {
    return {
      gradeHighOptions: gradeHighOptions,
      gradeMiddleOptions: gradeMiddleOptions,
      showGrade: false,
      gradeOption: [],
      gradeList: [],
      showSubject: false,
      subjectOptions: JSON.parse(JSON.stringify(subjectOptions)),
      oldSubjectOptions: JSON.parse(JSON.stringify(subjectOptions)),
      subjectList: [],
      gradetypecount: [],
      examTypeOptions: examTypeOptions,
      examTypeList: [],
      showExamType: false,
      yearList: [],
      showYear: false,
      gradeVal: "全部",
      subjectVal: "",
      examTypeVal: "全部",
      yearTypeVal: "全部",
      searchData: {
        current: 1,
        size: 10,
        token: "5041e254-c474-446d-8642-a4c7594ad89d",
        schoolID: 18,
      },
      level: 3,
      paperList: [],
      current: 1,
      pages: 2,
      // top: 0,
      // height: 0
    };
  },
  created() {
    this.getPhoneType();
  },
  mounted() {
    // 判断是否在web端打开
    let type = this.$route.query.isWeb;
    if (type) {
      this.$store.commit("setToken", this.$route.query.token);
      this.$store.commit("setSchoolId", this.$route.query.schoolID);
      this.apiData = {
        levelID: 3,
      };
      this.initOption();
      this.initSeaechData();
    } else {
      window.initView = this.initView;
      window.goBackView = this.goBackView;
      this.initMobile();
    }

    // window.addEventListener("scroll", this.disposeScroll); //监听滚动条
  },
  beforeDestroy() {
    //离开
    window.removeEventListener("scroll", this.disposeScroll); // 离开是后清除监听
  },
  methods: {
    getPhoneType() {
      let u = navigator.userAgent;
      // this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    },
    downWindow() {
      if (this.isiOS) {
        window.webkit.messageHandlers.commonCall.postMessage({
          type: 3,
        });
      } else {
        window.mobile.hideTitleBar();
      }
    },
    goBackView() {
      this.downView();
    },
    initMobile() {
      if (this.isiOS) {
        window.webkit.messageHandlers.commonCall.postMessage({
          type: 2,
        });
      } else {
        window.mobile.initMobile();
      }
    },
    initView(data) {
      this.apiData = data;
      this.$store.commit("setToken", this.apiData.token);
      this.$store.commit("setSchoolId", this.apiData.schoolID);
      // console.log()
      if (!this.apiData.levelID) {
        this.apiData.levelID = 3;
      }
      // this.getList();
      this.initOption();
      // this.getList();
      this.initSeaechData();
      this.downWindow();
    },
    linkTo(v) {
      v.countView++;
      this.$router.push({
        name: "ShowPaper",
        query: { id: v.id },
      });
    },
    disposeScroll() {
      if (this.page > this.pages) {
        return;
      } // 如果当前大于总页数，也就是最后一页，那么就不不触发了
      let top =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0; // 获取滚动条垂直的位置
      this.top = top + window.innerHeight;
      this.height = top + window.innerHeight;
      if (document.body.clientHeight - top - window.innerHeight < 20) {
        this.current++;
        this.initSeaechData();
        //如果滚动条的位置加上窗口的高度大于可见的窗口可见的高度，那么也就是滚动条到低了
        // this.$emit('update') // 执行update方法
      }
    },
    // 逻辑判断 处理搜索字段
    initSeaechData() {
      // let level = this.apiData.levelID;
      this.searchData.current = this.current;
      // this.searchData.level = level;
      this.gradeOption.forEach((index) => {
        if (this.gradeVal == index.label) {
          this.searchData.resGradeId = index.value;
        }
      });
      if (this.gradeVal == "全部") {
        this.searchData.resGradeId = "";
      }
      if (this.searchData.resGradeId < 500) {
        this.searchData.level = 2;
      } else {
        this.searchData.level = 3;
      }
      if (this.searchData.resGradeId == "") {
        this.searchData.level = 3;
      }
      this.subjectOptions.forEach((index) => {
        if (this.subjectVal == index.label) {
          this.searchData.subjectId = index.value;
        }
      });
      if (this.subjectVal == "全部") {
        this.searchData.subjectId = "";
      }
      this.examTypeOptions.forEach((index) => {
        if (this.examTypeVal == index.label) {
          this.searchData.type = index.value;
        }
      });
      if (this.examTypeVal == "全部") {
        this.searchData.type = "";
      }
      this.yearList.forEach((index) => {
        if (index == this.yearTypeVal) {
          this.searchData.year = index;
          this.searchData.beforeYear = 0;
        }
      });
      if (this.yearTypeVal == "全部") {
        this.searchData.year = 0;
        this.searchData.beforeYear = 0;
      }
      if (this.yearTypeVal == "更早") {
        this.searchData.year = 0;
        this.searchData.beforeYear = this.yearList[this.yearList.length - 2];
      }
      this.getList();
    },
    getList() {
      systemPage(this.searchData).then((res) => {
        if (this.current > 1) {
          this.paperList = this.paperList.concat(res.data.records);
        } else {
          window.addEventListener("scroll", this.disposeScroll); //监听滚动条
          this.paperList = res.data.records;
          this.pages = res.data.pages;
        }
      });
    },
    initOption() {
      //初始化年级 科目列表
      let level = this.apiData.levelID;
      this.gradeList.push("全部");
      // this.subjectList.push("全部");
      this.examTypeList.push("全部");
      this.yearList.push("全部");
      // let lecel
      if (level.split(",")[1]) {
        this.gradeOption = []
          .concat(this.gradeHighOptions)
          .concat(this.gradeMiddleOptions);
      } else {
        if (level == 3) {
          this.gradeOption = this.gradeHighOptions;
          let subjectOptions = this.oldSubjectOptions;
          this.subjectOptions = subjectOptions;
        } else {
          this.gradeOption = this.gradeMiddleOptions;
          let subjectOptions = this.oldSubjectOptions;
          this.subjectOptions = subjectOptions;
          this.subjectOptions.map((index) => {
            if (index.value == 6) {
              index.label = "道德与法治";
              index.value = 11;
            }
          });
        }
      }

      this.gradeOption.forEach((index) => {
        this.gradeList.push(index.label);
      });
      this.subjectOptions.forEach((index) => {
        this.subjectList.push(index.label);
      });
      this.subjectVal = this.subjectList[0];
      //考试类型所有列表
      this.examTypeOptions.forEach((index) => {
        this.examTypeList.push(index.label);
      });
      //年份
      let indexYear = new Date().getFullYear();
      for (let i = 0; i < 5; i++) {
        this.yearList.push(indexYear);
        indexYear--;
      }
      this.yearList.push("更早");
    },
    onConfirmYear(val) {
      this.current = 1;
      this.pages = 2;
      this.yearTypeVal = val;
      this.showYear = false;
      window.removeEventListener("scroll", this.disposeScroll); // 离开是后清除监听
      this.initSeaechData();
    },
    onConfirmGrade(val) {
      this.current = 1;
      this.pages = 2;
      this.gradeVal = val;
      this.showGrade = false;
      window.removeEventListener("scroll", this.disposeScroll); // 离开是后清除监听
      this.initSeaechData();
    },
    onConfirmExamType(val) {
      this.current = 1;
      this.pages = 2;
      this.examTypeVal = val;
      this.showExamType = false;
      window.removeEventListener("scroll", this.disposeScroll); // 离开是后清除监听
      this.initSeaechData();
    },
    onConfirmSubject(val) {
      this.current = 1;
      this.pages = 2;
      this.subjectVal = val;
      this.showSubject = false;
      window.removeEventListener("scroll", this.disposeScroll); // 离开是后清除监听
      this.initSeaechData();
    },
    downView() {
      if (this.isiOS) {
        window.webkit.messageHandlers.commonCall.postMessage({
          type: 1,
        });
      } else {
        window.mobile.closeMobileUI();
      }
    },
  },
};
</script>
<style scoped lang="scss">
.testPaper {
  background-color: rgba(0, 0, 0, 0.04);
  min-height: 100vh;
  // margin-top: 87px;

  padding-top: 87px;

  .paper-list-box {
    padding: 24px;
    .loading-box {
      text-align: center;
    }
    div {
      font-size: 12px;
    }
    .paper-list-cnt {
      color: rgba(0, 0, 0, 0.5);
      margin: 9px 0;
      span {
        margin-right: 8px;
      }
    }
    .paper-list-time {
      span {
        margin-right: 6px;
        color: rgba(0, 0, 0, 0.5);
      }
      .time {
        color: rgba(33, 150, 243, 100);
      }
    }
    .paper-list {
      padding: 12px;
      margin-bottom: 12px;
      border-radius: 4px;
      overflow: hidden;
      background-color: white;
      position: relative;
      img {
        position: absolute;
        right: 25px;
        width: 50px;
        top: 28px;
        // transform: rotateY(-50%);
      }
      .tips {
        position: absolute;
        top: 0;
        right: 0;
        padding: 3px 12px;
        border-radius: 0 0 0 4px;
        color: #ffffff;
      }
      .one-color {
        background-color: rgba(255, 171, 0, 100);
      }
      .two-color {
        background-color: rgba(11, 170, 142, 100);
      }
      .three-color {
        background-color: rgba(16, 198, 148, 100);
      }
      .four-color {
        background-color: rgba(233, 148, 20, 100);
      }
      .five-color {
        background-color: rgba(232, 210, 24, 100);
      }
      p {
        width: 80%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .muen-box {
    padding: 0 24px;
    background-color: white;
    display: flex;
    justify-content: space-between;
    position: fixed;
    width: 100%;
    left: 0;
    top: 44px;
    z-index: 10;
    div {
      padding: 12px 0;
      i {
        font-size: 14px;
        margin-left: 4px;
        color: rgba(0, 0, 0, 0.3);
        vertical-align: middle;
      }
    }
  }
}
</style>
